import packageJson from '../package.json'

export const appConfig = {
    common: {
        appName: import.meta.env.VITE_APP_NAME,
        appVersion: packageJson.version,
        appUri: import.meta.env.VITE_APP_URI,
        schedulerLicenseKey: import.meta.env.VITE_SCHEDULER_LICENSE_KEY
    }
}

export const apiConfig = {
    FACTORYBASE_API_URI: import.meta.env.VITE_APP_FACTORYBASE_API_URI,
    TIMEOUT: import.meta.env.VITE_APP_API_TIMEOUT,
    MOCKUP_API_URI: import.meta.env.VITE_APP_MOCKUP_API_URI
}
